<template>
  <div>
    <b-card class="bg-white rounded-xl">
      <div class="flex  justify-between  items-center">
        <div>
          <h2 class="text-2xl font-semibold">
            Analytics
          </h2>

          <small class=" text-muted "
            >Check your community performance here.
          </small>
        </div>
        <base-button type="warning" class="px-8">
          Export
        </base-button>
      </div>
      <Reports />
      <MIS />
      <div>
        <!-- <b-tabs pills class="nav-pills-w">
          <b-tab active>
            <template v-slot:title>
              SALES REPORTS
            </template>
            <Reports />
          </b-tab>

          <b-tab>
            <template v-slot:title>
              MIS
            </template>
            <MIS />
          </b-tab>
        </b-tabs> -->
      </div>
    </b-card>
  </div>
</template>
<script>
import "../../scss/Index.scss";
import MIS from "./components/MIS";
import Reports from "./components/Reports";
export default {
  data() {
    return {};
  },
  components: {
    Reports,
    MIS
  }
};
</script>
<style>
.nav-pills-w > div > .nav-pills li {
  width: 30%;
  text-align: center;
}
.nav-pills-w > div > .nav-pills {
  justify-content: start;
}
.nav-pills-w > div > .nav-pills li a {
  font-weight: 700;
}
</style>
